import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch } from "../store";

// Definimos el tipo de estado para `dataModelFile`
interface DataModelFileState {
  data: any | null;
}

// Estado inicial de `dataModelFile`
const initialState: DataModelFileState = {
  data: null,
};

const dataModelFileSlice = createSlice({
  name: "dataModelFile",
  initialState,
  reducers: {
    setData(state, action: PayloadAction<any>) {
      state.data = action.payload;
    },
  },
});

export const { setData } = dataModelFileSlice.actions;
export default dataModelFileSlice.reducer;

// Thunk para establecer los datos del archivo del modelo de datos
export const setDataModelFile = (data: any) => (dispatch: AppDispatch) => {
  dispatch(setData(data));
};
